const $ = require('jquery');

const $target = $('#load-here');

$('#load-more-winners').on('click', evt => {
  evt.preventDefault();

  $.ajax({
    url: drupalSettings.path.baseUrl + 'views/ajax',
    type: 'POST',
    dataType: 'json',
    data: 'view_name=why_i_ride_winners&view_display_id=block_2',
    success: function(response) {
      const output = response[3].data;
      $target.html(output);
      $('#load-more-winners').parent().remove();
    },
    error: function(data) {
      $target.html('An error occurred. Try refreshing the page and trying again. If it persists, please contact us!');
    }
  });
})
